enum Environment {
  local = 'local',
  development = 'development',
  staging = 'staging',
  production = 'production',
}

export function envIsDev() {
  const envs = [Environment.local, Environment.development];
  const env = process.env['NODE_ENV'] ?? '';
  return envs.includes(env as Environment) || false;
}

export function envIsProd() {
  const env = process.env['NODE_ENV'] ?? '';
  return env === Environment.production;
}
